import React from 'react';

export const usePopover = <TElement extends HTMLElement>(
  dynamicAnchor = false
) => {
  const [anchorEl, setAnchorEl] = React.useState<TElement | null>(null);
  const open = Boolean(anchorEl);
  const closePopover = () => {
    setAnchorEl(null);
  };
  const openPopover = (event: React.MouseEvent<TElement> | HTMLElement) => {
    if (event instanceof HTMLElement || event instanceof Node) {
      setAnchorEl(event as TElement);
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    if (!!anchorEl && !dynamicAnchor) {
      return;
    }
    setAnchorEl(event.currentTarget);
  };
  return {
    anchorEl,
    open,
    closePopover,
    openPopover,
  };
};
